<template>
  <div>
    <div class="height-100">
      <loading v-show="load"/>
      <div v-show="!load" class="container-fluid py-3">
        <modal-menu :menus="menus" :selected="menu" @changeMenu="(m) => { menu = m }"/>
        <div v-show="menu === 1">
          <div class="row">
            <div class="col-12 mb-2">
              <label class="mb-0">Impressora</label>
              <select v-model="dados.id_impressora" class="form-control" @change="atualizarNomeRegraPorImpressora">
                <option :value="null">Selecione uma impressora</option>
                <option
                  v-for="impressora in impressoras"
                  :key="impressora.id_impressora"
                  :value="impressora.id_impressora"
                >
                  {{ impressora.descricao }}
                </option>
              </select>
            </div>
            <div class="col-12 mb-2">
              <label class="mb-0">Nome da regra</label>
              <input
                v-model="dados.nome_regra"
                class="form-control"
                maxlength="100"
                placeholder="Ex: Impressão Cozinha"
                type="text"
              >
            </div>
            <div class="col-6 mb-2">
              <label class="mb-0">
                Layout
                <tooltip msg="Define se o documento será impresso em layout resumido ou completo."/>
              </label>
              <select v-model.number="dados.layout_tipo" class="form-control">
                <option :value="1">Resumido</option>
                <option :value="2">Completo</option>
              </select>
            </div>
            <div class="col-6 mb-2">
              <label class="mb-0">Qtd. cópias</label>
              <input
                v-model.number="dados.qtd_copias"
                class="form-control"
                min="1"
                type="number"
              >
            </div>
            <div class="col-12 mb-2">
              <label class="mb-0 d-block">
                Imprimir pedidos:
                <tooltip msg="Escolha em quais tipos de pedido esta regra deve ser aplicada: delivery, retirada e/ou consumo."/>
              </label>
              <label class="mr-3 mb-0">
                <input v-model.number="dados.pedido_delivery" :false-value="0" :true-value="1" type="checkbox">
                Delivery
              </label>
              <label class="mr-3 mb-0">
                <input v-model.number="dados.pedido_retirada" :false-value="0" :true-value="1" type="checkbox">
                Retirada
              </label>
              <label class="mb-0">
                <input v-model.number="dados.pedido_consumo" :false-value="0" :true-value="1" type="checkbox">
                Consumo
              </label>
            </div>
          </div>
        </div>
        <div v-show="menu === 2">
          <label class="mb-0">
            Tipo seleção
            <tooltip msg="Todos: a regra sempre entra. Parcial por categoria: a regra só entra quando o pedido tiver itens das categorias selecionadas."/>
          </label>
          <select v-model.number="dados.tipo_selecao" class="form-control mb-2">
            <option :value="1">Todos</option>
            <option :value="2">Parcial por categoria</option>
          </select>
          <div v-if="dados.tipo_selecao === 2">
            <label class="mb-0">
              Tipo impressão
              <tooltip msg="Somente itens da seleção: imprime apenas os produtos filtrados pelas categorias. Pedido completo: imprime o pedido inteiro mesmo quando a regra foi acionada por categoria."/>
            </label>
            <select v-model.number="dados.tipo_impressao" class="form-control mb-3">
              <option :value="1">Somente itens da seleção</option>
              <option :value="2">Pedido completo</option>
            </select>
          </div>
          <div v-show="dados.tipo_selecao === 2" class="border p-2 rounded">
            <div v-for="categoria in categorias" :key="categoria.id_categoria" class="mb-1">
              <label class="mb-0">
                <input
                  v-model="dados.categorias"
                  :value="categoria.id_categoria"
                  class="mr-2"
                  type="checkbox"
                >
                {{ categoria.nome_categoria }}
              </label>
            </div>
            <div v-if="!categorias.length" class="small text-muted">
              Nenhuma categoria encontrada.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="border-top p-2 text-center d-flex justify-content-between">
      <div class="d-flex justify-content-between w-100">
        <button class="btn btn-light border p-3" @click="$emit('fechar')">
          <i class="fa fa-angle-left"></i> Voltar
        </button>
        <button :disabled="load" class="btn btn-success px-4 p-3" @click="salvarRegra">
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ModalMenu from "@/components/commons/ModalMenu";
import Tooltip from "@/components/commons/Tooltip";
import Loading from "../../gestor/loading";

export default {
  name: "RegraImpressaoNova",
  components: { Loading, ModalMenu, Tooltip },

  props: {
    impressoras: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      token: localStorage.getItem('key'),
      load: false,
      categorias: [],
      menus: [
        { nome: 'Config', active: true },
        { nome: 'Categorias', active: true }
      ],
      menu: 1,
      dados: {
        id_impressao_regra: null,
        nome_regra: '',
        id_impressora: null,
        layout_tipo: 2,
        tipo_selecao: 1,
        tipo_impressao: 1,
        pedido_delivery: 1,
        pedido_retirada: 1,
        pedido_consumo: 1,
        qtd_copias: 1,
        categorias: []
      }
    }
  },

  methods: {
    normalizarDados(regra) {
      return {
        id_impressao_regra: regra && regra.id_impressao_regra ? regra.id_impressao_regra : null,
        nome_regra: regra && regra.nome_regra ? regra.nome_regra : '',
        id_impressora: regra && regra.id_impressora ? Number(regra.id_impressora) : null,
        layout_tipo: Number(regra && regra.layout_tipo ? regra.layout_tipo : 2),
        tipo_selecao: Number(regra && regra.tipo_selecao ? regra.tipo_selecao : 1),
        tipo_impressao: Number(regra && regra.tipo_impressao ? regra.tipo_impressao : 1),
        pedido_delivery: Number(regra && regra.pedido_delivery != null ? regra.pedido_delivery : 1),
        pedido_retirada: Number(regra && regra.pedido_retirada != null ? regra.pedido_retirada : 1),
        pedido_consumo: Number(regra && regra.pedido_consumo != null ? regra.pedido_consumo : 1),
        qtd_copias: Number(regra && regra.qtd_copias ? regra.qtd_copias : 1),
        categorias: Array.isArray(regra && regra.categorias) ? regra.categorias.map(categoria => Number(categoria.id_categoria || categoria)) : []
      };
    },

    buscarCategorias() {
      if (this.categorias.length) {
        return;
      }

      this.load = true;
      this.$http.get('categorias/' + this.token)
        .then(response => {
          this.load = false;
          this.categorias = response.data || [];

        }, res => {
          this.load = false;
          this.$swal((res.data || {}).erro || (res.data || {}).msg || "Erro temporário");
        });
    },

    atualizarNomeRegraPorImpressora() {
      const impressora = this.impressoras.find(item => Number(item.id_impressora) === Number(this.dados.id_impressora));

      if (!impressora) {
        return;
      }

      this.dados.nome_regra = `Impressão ${impressora.descricao}`;
    },

    salvarRegra() {
      if (!this.dados.nome_regra.trim()) {
        this.$swal("Informe o nome da regra.");
        return;
      }

      if (!this.dados.id_impressora) {
        this.$swal("Selecione uma impressora para a regra.");
        return;
      }

      if (!Number(this.dados.pedido_delivery) && !Number(this.dados.pedido_retirada) && !Number(this.dados.pedido_consumo)) {
        this.$swal("Selecione pelo menos um tipo de pedido.");
        return;
      }

      if (Number(this.dados.tipo_selecao) === 2 && !this.dados.categorias.length) {
        this.$swal("Selecione pelo menos uma categoria para a impressão parcial.");
        return;
      }

      const payload = {
        nome_regra: this.dados.nome_regra.trim(),
        id_impressora: Number(this.dados.id_impressora),
        layout_tipo: Number(this.dados.layout_tipo || 2),
        tipo_selecao: Number(this.dados.tipo_selecao || 1),
        tipo_impressao: Number(this.dados.tipo_impressao || 1),
        pedido_delivery: Number(this.dados.pedido_delivery || 0),
        pedido_retirada: Number(this.dados.pedido_retirada || 0),
        pedido_consumo: Number(this.dados.pedido_consumo || 0),
        qtd_copias: Number(this.dados.qtd_copias || 1),
        categorias: Number(this.dados.tipo_selecao) === 2
          ? this.dados.categorias.map(categoria => Number(categoria))
          : []
      };

      if (this.dados.id_impressao_regra) {
        payload.id_impressao_regra = this.dados.id_impressao_regra;
      }

      this.load = true;
      this.$http.post('v2/impressao/regra', payload)
        .then(response => {
          this.load = false;

          if (response.data?.success) {
            this.$swal(
              this.dados.id_impressao_regra
                ? "Regra editada com sucesso!"
                : "Regra cadastrada com sucesso!"
            );
            this.$emit('salvar');
            return;
          }

          this.$swal("Erro ao salvar regra de impressão.");

        }, res => {
          this.load = false;
          this.$swal((res.data || {}).erro || (res.data || {}).msg || "Erro temporário");
        });
    }
  },

  created() {
    this.buscarCategorias();
    this.$parent.$on('loadDadosModal', (regra) => {
      this.menu = 1;
      this.dados = this.normalizarDados(regra || {});
    });
  }
}
</script>
